/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrFunduscopyTypename = "PhrFunduscopy" as const;

/**
 *
 * @export
 * @interface PhrFunduscopy
 */
export interface PhrFunduscopy {
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  davis?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  impression?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  keithWagener?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  scheieH?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  scheieS?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  target?: string;
  /**
   *
   * @type {string}
   * @memberof PhrFunduscopy
   */
  wongMichell?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrFunduscopy
   */
  readonly __typename?: string;
}

export function PhrFunduscopyFromJSON(json: any): PhrFunduscopy {
  return PhrFunduscopyFromJSONTyped(json, false);
}

export function PhrFunduscopyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrFunduscopy {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrFunduscopyTypename,

    davis: !exists(json, "davis") ? undefined : json["davis"],
    impression: !exists(json, "impression") ? undefined : json["impression"],
    keithWagener: !exists(json, "keith_wagener") ? undefined : json["keith_wagener"],
    reason: !exists(json, "reason") ? undefined : json["reason"],
    scheieH: !exists(json, "scheie_h") ? undefined : json["scheie_h"],
    scheieS: !exists(json, "scheie_s") ? undefined : json["scheie_s"],
    target: !exists(json, "target") ? undefined : json["target"],
    wongMichell: !exists(json, "wong_michell") ? undefined : json["wong_michell"],
  };
}

export function PhrFunduscopyToJSON(object?: PhrFunduscopy | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    davis: value.davis,
    impression: value.impression,
    keith_wagener: value.keithWagener,
    reason: value.reason,
    scheie_h: value.scheieH,
    scheie_s: value.scheieS,
    target: value.target,
    wong_michell: value.wongMichell,
  };
}
